import { useState, type ReactNode } from 'react'
import { downloadBerkas, type ObyekQuery } from '@/lib/api'
import { Button } from './Button'
import { useToast } from './Toast'

export interface FormatEkspor {
  path: string
  namaDasar: string
  query?: ObyekQuery
}

/**
 * Judul halaman + deskripsi + slot aksi. Bila `ekspor` diisi, tombol ekspor
 * (JSON/CSV/XLSX/PDF) dirender otomatis memakai `downloadBerkas`.
 */
export function PageHeader({
  judul,
  deskripsi,
  aksi,
  ekspor,
  remah,
}: {
  judul: string
  deskripsi?: ReactNode
  aksi?: ReactNode
  ekspor?: FormatEkspor
  remah?: ReactNode
}) {
  const [sedang, setSedang] = useState<string | null>(null)
  const toast = useToast()

  const unduh = async (format: 'csv' | 'xlsx' | 'pdf' | 'json') => {
    if (!ekspor) return
    setSedang(format)
    try {
      const ekstensi = format
      await downloadBerkas(ekspor.path, `${ekspor.namaDasar}.${ekstensi}`, {
        ...(ekspor.query ?? {}),
        format,
      })
      toast.sukses(`Berkas ${format.toUpperCase()} berhasil diunduh.`)
    } catch (e) {
      toast.gagal(e instanceof Error ? e.message : 'Gagal mengunduh berkas.')
    } finally {
      setSedang(null)
    }
  }

  return (
    <header className="mb-5 flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        {remah ? <div className="mb-1 text-xs text-netral-500">{remah}</div> : null}
        <h1 className="text-xl font-semibold text-netral-900">{judul}</h1>
        {deskripsi ? <p className="mt-1 max-w-3xl text-sm text-netral-500">{deskripsi}</p> : null}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        {aksi}
        {ekspor ? (
          <div className="flex items-center gap-1.5 rounded-lg border border-netral-200 bg-white px-2 py-1.5">
            <span className="text-xs font-medium text-netral-500">Ekspor</span>
            {(['csv', 'xlsx', 'pdf'] as const).map((f) => (
              <Button
                key={f}
                varian="halus"
                ukuran="kecil"
                memuat={sedang === f}
                onClick={() => void unduh(f)}
              >
                {f.toUpperCase()}
              </Button>
            ))}
          </div>
        ) : null}
      </div>
    </header>
  )
}
